import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { SubmitDialogeComponent } from 'src/app/common/components/submit-dialoge/submit-dialoge.component';
import { getNamcIdForName, getTodayDate, trimSupplierCode } from 'src/app/common/custom.method';
import { apiEndPoints, apiQueryParams, hotCallStatusCode } from 'src/app/common/enums/common.enum';
import { CREATE_HOT_CALL_TICKET, GET_DUPLICATE_HOT_CALL } from 'src/app/common/graphql/queries';
import { CheckKanbanResponse, CheckKanbanResponseBody } from 'src/app/common/models/checkKanban.model';
import { GetRunOutInfoApiResponse, RunOutData } from 'src/app/common/models/getRunOutInfo.model';
import { GetSinglePartApiResponse, Part, ResponseBody } from 'src/app/common/models/getSInglePartDetails.model';
import { GetVehiclDetailsApiResponse } from 'src/app/common/models/getVehicleDetails.model';
import { GetFirstSequenceApiResponse } from 'src/app/common/models/getFirstSequenceNo.model';
import { ProfileData } from 'src/app/common/models/loginPreference.model';
import { CommonserviceService } from 'src/app/common/services/commonservice.service';
import { UpdateRunoutInformationComponent } from '../update-runout-information/update-runout-information.component';
import { DataService } from 'src/app/common/services/data.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { ErrorHandlerService } from 'src/app/common/services/error-handler.service';
import { recentHotCallsSignal } from 'src/app/common/signals/recent-hot-call-signal';

@Component({
  selector: 'app-create-hot-call-form',
  templateUrl: './create-hot-call-form.component.html',
  styleUrl: './create-hot-call-form.component.css'
})
export class CreateHotCallFormComponent implements AfterViewInit {
  @ViewChild('autoFocusKanban') autoFocusKanban: ElementRef;
  form: FormGroup;
  @Input() currentSection: number = 1;
  runOutData: RunOutData;
  oldRunOutInfo: RunOutData;
  recentHotCallData = recentHotCallsSignal();
  scanFailed: boolean = false;
  scanInput: string = '';
  scanErrorMessage: string | null = null;
  selectedOption: string = '1';
  inputValue: string = '';
  percentages: number[] = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  selectedPercentage: number = 10;
  businessEntity: string = "01";
  timeLeft: number = 180; // 3 minutes in seconds
  isExpired: boolean = false;
  isErrorMessageVisible: boolean = false;
  isDuplicateTicket: boolean = false;
  private timerSubscription?: Subscription;
  private readonly destroy$ = new Subject<void>();
  selectedValue: string;
  options: string[];
  deliveryoptions: string[];
  scannedResult: string = '';
  kanbanFlag: boolean;
  errorList: string[] = [];
  successList: string[] = [];
  userRoles: ProfileData;
  deliveryDropdown = false;
  isLoading: boolean = false;
  singlePartResponseData: ResponseBody;
  namcId: string = '';
  currentTime = new Date().toLocaleTimeString();
  dockDropdown: boolean = false;
  kanbanValueChangeSubscription: Subscription;
  quantityTypeSubscription: Subscription;
  partNumberSubscription: Subscription;
  sequenceNumberSubscription: Subscription;
  bodyNumberSubscription: Subscription;
  hotCallTicket: string ='';
  disableSubmit: boolean = false;
  duplicateTicketId: string = '';

  constructor(public dialog: MatDialog, private readonly fb: FormBuilder,
    private readonly translate: TranslateService,
    private readonly renderer: Renderer2,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly dataService: DataService,
    private readonly service: CommonserviceService,
    private readonly spinner: SpinnerService,
    private readonly errorService: ErrorHandlerService
  ) { }
  ngAfterViewInit(): void {
    this.renderer.selectRootElement(this.autoFocusKanban?.nativeElement).focus();
  }

  ngOnInit(): void {
    this.errorService.clearErrorMessage();
    this.form = this.fb.group({
      kanban: ['', Validators.required],
      partnumber: ['', Validators.required],
      supplier: ['', Validators.required],
      dock: ['', Validators.required],
      storeAddress: ['', Validators.required],
      deliveryAddress: ['', Validators.required],
      partQpc: [''],
      lineSideComments: [''],
      sequenceNumber: ['', [Validators.required]],
      bodyNumber: ['', [Validators.required]],
      quantityType: ['1'],
      quantityOfBox: [],
      percentageOfBox: [null],
      numberOfFullBoxes: []
    });
    this.getNamcName();

    // Retrieve saved section from sessionStorage
    const savedSection = sessionStorage.getItem('currentSection');
    if (savedSection) {
      this.currentSection = Number(savedSection);
    } else {
      this.currentSection = 1; // Default to section 1 if nothing is stored
    }

    // Update the data service with the restored section
    this.dataService.updateStepNumber(this.currentSection);
    this.dataService.currentSection.subscribe(section => {
      this.currentSection = section;
      sessionStorage.setItem('currentSection', section.toString()); // Save updated section
    });
    if(this.currentSection == 3 && this.recentHotCallData) {
      this.recentHotCallData.forEach(hotCall => {
        this.hotCallTicket = hotCall.ticketId;
        this.runOutData = {
          supplierCode: hotCall.sp,
          dockCode: hotCall.dk,
          kanbanCode: hotCall.kb,
          partNumber: hotCall?.partNumber || '',
          linesideAddress: hotCall?.linesideAddress || '',
          currentBodyNumber: hotCall.body,
          piecesRemaining: hotCall.pcsRem,
          vehiclesToEmpty: parseInt(hotCall.intVhcleEmpty),
          firstMissedPartSeqNo: hotCall.firMsdSeq,
          firstMissedPartBodyNo: hotCall?.firstMissedPartBodyNo || '',
          tpCount: hotCall.tpCount || '',
          tpErrorMessage: hotCall?.tpErrorMessage || '',
          currentVehicleSeq: hotCall?.currentVehicleSeq || '',
          lineSideComments: hotCall?.lineSideComments || ''
        }
      });
    }
    const scannedResult = this.route.snapshot.queryParamMap.get('scannedResult');
    if (scannedResult) {
      if (scannedResult.length === 250) {
        this.scannedResult = scannedResult.substring(38, 42);
        this.kanbanFlag = true;
        this.form.patchValue({ kanban: this.scannedResult });
        this.callGetPartByKanbanApi(this.scannedResult, this.namcId);
      } else if (scannedResult.length === 152) {
        this.scannedResult = scannedResult.substring(64, 76);
        this.kanbanFlag = false;
        this.form.patchValue({ partnumber: this.scannedResult });
        this.getSinglePartDetails(this.namcId);
      }
    }

    this.getLoggedInUserDetails();
    // const savedPreferences = sessionStorage.getItem('userPreference');
    // if (savedPreferences) {
    //   const { language, ...rest } = JSON.parse(savedPreferences);
    //   this.userRoles = rest;
    // }

    this.quantityTypeSubscription = this.form.get('quantityType')?.valueChanges.subscribe(value => {
      if (value === '2') {
        this.form.patchValue({ quantityBox: '' });
      } else {
        this.form.patchValue({ percentageOfBox: '' });
      }
    });

    // Subscribe to kanban changes (with unsubscribe handling)
    this.kanbanValueChangeSubscription = this.form.get('kanban')?.valueChanges.subscribe(value => {
      if (!value) {
        this.kanbanValueChangeSubscription.unsubscribe();
        this.form.patchValue({
          partnumber: '',
          supplier: '',
          dock: '',
          storeAddress: '',
          deliveryAddress: '',
          partQpc: '',
          lineSideComments: '',
          quantityType: '1',
          quantityOfBox: null,
          percentageOfBox: null,
          numberOfFullBoxes: null
        });
        this.resetFormFieldsExcept(['sequenceNumber', 'bodyNumber', 'kanban']);
      }
    });

    // Subscribe to partnumber changes
    this.partNumberSubscription = this.form.get('partnumber')?.valueChanges.subscribe(value => {
      if (!value) {
        this.form.patchValue({
          kanban: '',
          supplier: '',
          dock: '',
          storeAddress: '',
          deliveryAddress: '',
          partQpc: '',
          lineSideComments: '',
          quantityType: '1',
          quantityOfBox: null,
          percentageOfBox: null,
          numberOfFullBoxes: null
        });
        this.resetFormFieldsExcept(['sequenceNumber', 'bodyNumber', 'partnumber']);
      }
    });

    // Subscribe to sequenceNumber changes
    this.sequenceNumberSubscription = this.form.get('sequenceNumber')?.valueChanges.subscribe(value => {
      if (!value) {
        this.form.patchValue({ bodyNumber: '' });
      }
    });

    // Subscribe to bodyNumber changes
    this.bodyNumberSubscription = this.form.get('bodyNumber')?.valueChanges.subscribe(value => {
      if (!value) {
        this.form.patchValue({ sequenceNumber: '' });
      }
    });

  }

  getLoggedInUserDetails():void{
    this.dataService.getUserProfile().subscribe((response) =>{
      if(response) {
        this.userRoles = {
          plant: response?.plantName,
          shop: response?.shopName,
          lineName: response.lineName.split('|'),
          language : 'en',
        }
      }
    })
  }

  public isShopWithNoSequenceNumber(): boolean {
    return ['Store', 'Repair', 'BODYWELD 1'].includes(this.userRoles.shop);
  }

  resetFormFieldsExcept(excludedFields: string[]) {
    Object.keys(this.form.controls).forEach(field => {
      // Skip excluded fields
      if (!excludedFields.includes(field)) {
        const control = this.form.get(field);
        if (control) {
          control.markAsUntouched();
          control.setErrors(null);
          control.updateValueAndValidity();
        }
      }
    });
  }

  public joinValuesWithPipe(obj: { [key: string]: any }): string {
    const values = Object.values(obj).reduce((acc, val) => acc.concat(val), []);
    return values.join(' | ');
  }


  public onKanbanInputChange(): void {
    const kanbanValue = this.form.get('kanban')?.value;
    if (kanbanValue?.length === 4) {
      this.callGetPartByKanbanApi(kanbanValue, this.namcId);
    }}



  public onPartNumberInputChange(): void {
    const partNumberValue = this.form.get('partnumber')?.value;
    if (partNumberValue?.length === 12) {
      this.getSinglePartDetails(this.namcId);
    }
  }


  public onSequenceInputChange(): void {
    const sequenceNumberValue = this.form.get('sequenceNumber')?.value;
    if (sequenceNumberValue?.length === 3) {
      this.getVehicleDetails(this.namcId);
    }
  }


  public onBodyNumberInputChange(): void {
    const bodyNumberValue = this.form.get('bodyNumber')?.value;
    if (bodyNumberValue?.length === 5) {
      this.getVehicleDetails(this.namcId);
    }
  }

  public callGetPartByKanbanApi(kanban: string, business_entity: string): void {
    this.spinner.show();
    let query = `${apiEndPoints.GetPlanLineByKanban}?${apiQueryParams.business_entity}=${business_entity}&${apiQueryParams.kanbanCode}=${kanban}`
    this.service.getPieData(query).subscribe({
      next: (data: CheckKanbanResponse) => {
        if (data?.hasError === 'false' && data?.httpStatusCode === '200') {
          if (data?.responseBody.length > 0) {
            this.errorList = [];
            const validationResult = this.validateData(data?.responseBody);
            if (validationResult) {
              this.form.get('kanban')?.setErrors(null);
              this.getSinglePartDetails(this.namcId);
            } else {
              this.form.get('kanban')?.setErrors({
                'invalid': `Kanban is invalid for the line ( ${this.joinValuesWithPipe(this.userRoles)} ). Kanban belongs to (  ${this.getValidationMessage(data?.responseBody)} )`
              });
            }
            this.spinner.hide();
          } else {
            this.form.get('kanban')?.setErrors({
              'invalid': `Kanban is invalid for the line ( ${this.joinValuesWithPipe(this.userRoles)})`
            });
            this.successList = [];
            this.spinner.hide();
          }
        } if (data?.hasError === 'true' && data?.responseMessage) {
          this.spinner.hide();
          this.successList = [];
          this.errorService.setErrorMessage([data.responseMessage]);
        }
        // if(data?.hasError === 'true' && data?.responseBody?.Errors?.errorsMsg) {
        //   this.successList = [];
        //   this.errorService.setErrorMessage([data.responseBody.Errors.errorsMsg]);
        // }
      },
      error: (error: any) => {
        this.successList = [];
        this.errorService.setErrorMessage([]);
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
      }
    })
  }

  public getValidationMessage(request: CheckKanbanResponseBody[]): string {
    const plantData = request.find(plant => plant.plant_name === this.userRoles.plant);
    if (!plantData) {
      const result = request.map(item => {
        return `${item.plant_name}|${item.shop_name}|${item.line_name}`;
      }).join(' | ');
      return result;
    }
    return Object.values(plantData).reduce((acc, val) => acc.concat(val), []).join(' | ');
  }

  public validateData(request: CheckKanbanResponseBody[]): boolean {
    const plantData = request.find(plant => plant.plant_name === this.userRoles.plant);
    if (!plantData) {
      return false;
    }
    if (plantData.shop_name !== this.userRoles.shop) {
      return false;
    }
    const lineNames = Array.isArray(this.userRoles.lineName) ? this.userRoles.lineName : [this.userRoles.lineName];
    const validLine = lineNames.some((line: string) => line === plantData.line_name);
    if (!validLine) {
      return false;
    }
    return true;
  }

  public getSinglePartDetails(business_entity: string): void {
    this.spinner.show();
    const kanban = this.form.get('kanban')?.value;
    const partNumber = this.form.get('partnumber')?.value;
    const lineNames = Array.isArray(this.userRoles.lineName) ? this.userRoles.lineName.join('|') : this.userRoles.lineName;
    const query = `${apiEndPoints.GetSingleParts}?${apiQueryParams.business_entity}=${business_entity}&${apiQueryParams.PlantName}=${this.userRoles.plant}&${apiQueryParams.ShopName}=${this.userRoles.shop}&${apiQueryParams.LineName}=${encodeURIComponent(lineNames)}&${apiQueryParams.SingleKanban}=${kanban}&${apiQueryParams.PartNo}=${partNumber}`;
    this.service.getPieData(query).subscribe({
      next: (data: GetSinglePartApiResponse) => {
        if (data?.hasError === 'false' && data?.httpStatusCode === '200') {
          this.errorList = [];
          this.singlePartResponseData = data?.responseBody;
          if (data?.responseBody?.parts.length > 1) {


            this.deliveryoptions = this.extractDeliveryAddresses(data?.responseBody?.parts);
            this.options = this.extractDocks(data?.responseBody?.parts);
            if(this.options.length > 1){
              this.dockDropdown = true;
               // enable dropdown foR delivery address
              this.deliveryDropdown = true;
            }
          }
          this.form.patchValue({
            partnumber: data?.responseBody?.parts[0]?.partsList,
            kanban: data?.responseBody?.parts[0]?.kanban,
            supplier: trimSupplierCode(this.form.get('supplier')?.value || this.runOutData?.supplierCode || data?.responseBody?.parts[0]?.supplierDockPartAddressList?.supplierCd || ''),
            dock: !this.dockDropdown && data?.responseBody?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.dockCd,
            storeAddress: data?.responseBody?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.partAddressList?.storeAddress,
            deliveryAddress: !this.deliveryDropdown && data?.responseBody?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.partAddressList?.lineSideAddress,
            partQpc: data?.responseBody?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.qpC_Qty
          });
          this.spinner.hide();
        }  if (data?.hasError === 'true' && data?.responseMessage) {
          this.spinner.hide();
          this.successList = [];
          this.errorService.setErrorMessage([data.responseMessage]);
        }
        if(data?.hasError === 'true' && data?.responseBody?.Errors?.errorsMsg) {
          this.spinner.hide();
          this.successList = [];
          this.errorService.setErrorMessage(data.responseBody.Errors.errorsMsg);
        }
      },
      error: (error: any) => {
        this.errorService.setErrorMessage([]);
        this.spinner.hide();
      },
      complete: () => {
        this.spinner.hide();
      }
    })
  }

  public extractDeliveryAddresses(response: Part[]): string[] {
    if (Array.isArray(response)) {
      const data =  response.map((part: Part) =>
        part.supplierDockPartAddressList?.dockPartAddressList?.partAddressList?.lineSideAddress
      ).filter((address: string) => address !== undefined);
      return [...new Set(data)];
    }
    return [];
  }

  public extractDocks(response: Part[]): string[] {
    if (Array.isArray(response)) {
      const data =  response.map((part: Part) =>
        part?.supplierDockPartAddressList?.dockPartAddressList?.dockCd
      ).filter((address: string) => address !== undefined);
      return [...new Set(data)];
    }
    return [];
  }

  public startTimer(): void {
    this.timeLeft = 180;
    this.isExpired = false;
    this.isErrorMessageVisible = false;
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.timerSubscription = interval(1000)
      .pipe(
        takeWhile(() => this.timeLeft > 0)
      )
      .subscribe(() => {
        this.timeLeft--;
        if (this.timeLeft === 0) {
          this.isExpired = true;
        }
      });
  }

  public onScanOWKButtonClick(): void {
    this.router.navigate(['/scanner'])
  }

  public goBack(): void {
    this.currentSection = 1;
    this.form.get('bodyNumber')?.clearValidators();
    this.form.get('sequenceNumber')?.clearValidators();
    this.form.get('bodyNumber')?.updateValueAndValidity();
    this.form.get('sequenceNumber')?.updateValueAndValidity();
  }


  public navigateToInventory(): void {
    this.errorService.clearErrorMessage();
    this.handleShopCondition();
    if (this.form.get('kanban')?.invalid) {
      this.form.get('kanban')?.markAsTouched();
      return;
    }

    const quantityOfBox = this.form.get('quantityOfBox')?.value;
    const numberOfFullBoxes = this.form.get('numberOfFullBoxes')?.value;
    if ((quantityOfBox === 0 || quantityOfBox < 0 || quantityOfBox === null) && (numberOfFullBoxes === 0 || numberOfFullBoxes < 0 || numberOfFullBoxes === null)) {
      this.translate.get(['inventoryValidation.title', 'inventoryValidation.message']).subscribe(translations => {
        const dialogRef = this.dialog.open(SubmitDialogeComponent, {
          width: '716px',
          panelClass: 'centered-dialog',
          data: {
            message: translations['inventoryValidation.message'],
            title: translations['inventoryValidation.title'],
            action: "Inventory Error",
            showCancelButton: true,
            showAlert: true,
            showYesInvButton: true,
          }
        });
        dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
          if (result) {
            this.currentSection = 2;
            this.dataService.updateStepNumber(2);
          } else {
            this.currentSection = 1;
          }
        });
      });
    } else {
      this.currentSection = 2;
      this.dataService.updateStepNumber(2);
    }
  }

  public numberOnly(event: KeyboardEvent): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public formatSequenceNumber(): void {
    const sequenceControl = this.form.get('sequenceNumber');
    if (sequenceControl && sequenceControl.value) {
      const value = sequenceControl.value.toString();
      // Pad with leading zeros to make it 3 digits
      const formattedValue = value.padStart(3, '0');
      sequenceControl.setValue(formattedValue);
    }
  }

  public formatBodyNumber(): void {
    const bodyControl = this.form.get('bodyNumber');
    if (bodyControl && bodyControl.value) {
      const value = bodyControl.value.toString();
      // Pad with leading zeros to make it 5 digits
      const formattedValue = value.padStart(5, '0');
      bodyControl.setValue(formattedValue);
    }
  }

  public navigateToInquiry(): void {
    this.errorService.clearErrorMessage();
    const bodyNumberInvalid = this.form.get('bodyNumber')?.invalid;
    const sequenceNumberInvalid = this.form.get('sequenceNumber')?.invalid;

    if (bodyNumberInvalid || sequenceNumberInvalid) {
      // If either field is invalid, mark all fields as touched
      this.form.markAllAsTouched();
    }

    if (sequenceNumberInvalid && !bodyNumberInvalid) {
      // If sequenceNumber is invalid and bodyNumber is valid
      this.getRunOutInformation(this.namcId)
    } else if (!sequenceNumberInvalid && !bodyNumberInvalid) {
      // If both fields are valid
      this.getRunOutInformation(this.namcId)
    }
  }


  public onHotCallSubmit(action: string): void {
    this.spinner.show();
    if (!this.isExpired && !this.isDuplicateTicket) {
      const todaydate: string = getTodayDate();
      const input = {
        hcTktId: action === 'Cancel' ? this.hotCallTicket: action === 'Submit' ? this.hotCallTicket: '',
        hcTktStatId: action === 'Inquiry' ? hotCallStatusCode.PotentialShortage : action === 'Cancel' ? hotCallStatusCode.Cancelled : hotCallStatusCode.Open,
        namcId: this.namcId,
        supCd: trimSupplierCode(this.form.get('supplier')?.value || this.runOutData?.supplierCode || ''),
        dckCd: this.form.get('dock')?.value || this.runOutData?.dockCode || '',
        knbnNbr: this.form.get('kanban')?.value || this.runOutData?.kanbanCode || '',
        partNbr: this.form.get('partnumber')?.value || this.runOutData?.partNumber || '',
        scnBcdTxt: "", // Need to check where this value is coming from
        partDesc: this.singlePartResponseData?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.partDescriptionTxt || "",
        lsAddrTxt: this.form.get('deliveryAddress')?.value,
        streAddrTxt: this.form.get('storeAddress')?.value,
        plltCd: this.singlePartResponseData?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.palletCd || "",
        dpthAddrTxt: "",  // Need to check where this value is coming from
        spltCd: this.singlePartResponseData?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.specialistCd || "",
        pcCnt: this.form.get('quantityOfBox')?.value || 0,
        pctgCnt: this.selectedPercentage,
        fullBxCnt: this.form.get('numberOfFullBoxes')?.value || 0,
        mnftBcdTxt: "",
        seqNbr: parseInt(this.form.get('sequenceNumber')?.value || this.runOutData?.firstMissedPartSeqNo) || 0,
        bdyNbr: parseInt(this.form.get('bodyNumber')?.value || this.runOutData?.firstMissedPartBodyNo) || 0,
        plntNm: this.userRoles.plant,
        shpNm: this.userRoles.shop,
        lnGrpNm: '',
        lnNm: Array.isArray(this.userRoles.lineName) ? this.userRoles.lineName.join('|') : this.userRoles.lineName,
        atchId: 789, // Need to check where this value is coming from
        initVhleToEmtyCnt: this.runOutData?.vehiclesToEmpty || 0, // Coming from runout info response
        frstSeqNbrToEmtyCnt: 0, // Need to check where this value is coming from
        frstBdyNbrToEmtyCnt: 0, // Need to check where this value is coming from
        initTrkPtCnt: parseInt(this.runOutData?.tpCount) || 0, // Coming from runout info response
        inqDt: todaydate,
        pcRmnCnt: 0, // Need to check where this value is coming from
        ltstVhleToEmtyCnt: 0, // Need to check where this value is coming from
        ltstTrkPntCnt: 0, // Need to check where this value is coming from
        cnynRcptFlg: "N",
        lstDlvOrdrNbr: "", // Need to check where this value is coming from
        lstDlvCycNbr: "", // Need to check where this value is coming from
        lstUnldOrdrNbr: "", // Coming from runout info response
        lstUnldCycNbr: "", // Need to check where this value is coming from
        lsCmtTxt: this.form.get('lineSideComments')?.value || "",
        qpcCnt: parseInt(this.form.get('partQpc')?.value) || 0,
        lfCycCd: this.singlePartResponseData?.parts[0]?.supplierDockPartAddressList?.dockPartAddressList?.life_Cycle || "",
        crtdBy: this.dataService.getWorkDayId().toString(),
        crtdDt: todaydate,
        updtDt: todaydate,
        updtBy: this.dataService.getWorkDayId().toString()
      }
      this.service.getHcmData(CREATE_HOT_CALL_TICKET, { input }).subscribe({
        next: (response) => {
          if (response?.data?.createHotCallTicket?.message) {
            const message = response?.data?.createHotCallTicket?.message;
            const hotCallTicketMatch = message.match(/HCM-\w+-\d+/);
            this.hotCallTicket = hotCallTicketMatch ? hotCallTicketMatch[0] : '';
            if (action === 'Submit' || action === 'Cancel') this.hotCallSubmitDialog(action);
            this.spinner.hide();
          } if(response?.data?.errors || response?.errors) {
            this.spinner.hide();
            this.errorList = [];
            this.errorService.setErrorMessage([]);
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.errorService.setErrorMessage([]);
        },
        complete: () => {
          this.spinner.hide();
        }
      });
    }
  }
  public hotCallSubmitDialog(action: string): void {
    const translationKeys = action === 'Submit' ? ['submitHotCall.title', 'submitHotCall.message'] : ['cancelHotCall.title', 'cancelHotCall.message'];
    this.translate.get(translationKeys).subscribe(translations => {
      const dialogRef = this.dialog.open(SubmitDialogeComponent, {
      width: '568px',
      panelClass: 'centered-dialog',
      data: {
        message: translations[translationKeys[1]],
        title: translations[translationKeys[0]],
        action: action === 'Submit' ? 'Submit Hot Call' : 'Cancel Hot Call Message',
        showOkButton: true,
        showSuccess: true,
      }
      });
      dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
      if (result) {
        this.startTimer(); // Reset timer after successful submission
        this.router.navigateByUrl('home');
      }
      });
    });
  }

  public duplicateHotCallCheck(action: string): void {
    const input = {
      ticketStatus : hotCallStatusCode.Open,
      lsAddrTxt: this.form.get('deliveryAddress')?.value,
      suplCd: this.form.get('supplier')?.value,
      dockCd: this.form.get('dock')?.value,
      knbnNbr: this.form.get('kanban')?.value,
    }
    this.service.getHcmData(GET_DUPLICATE_HOT_CALL, { input }).subscribe({
      next: (response) => {
        if (response?.data?.getDuplicateHotCalls.length > 0) {
          this.isDuplicateTicket = true;
          this.duplicateTicketId = response?.data?.getDuplicateHotCalls[0].ticketId;
            this.oldRunOutInfo = {
            supplierCode: response?.data?.getDuplicateHotCalls[0].suplCd,
            dockCode: response?.data?.getDuplicateHotCalls[0].dockCd,
            kanbanCode: response?.data?.getDuplicateHotCalls[0].knbnNbr,
            partNumber: response?.data?.getDuplicateHotCalls[0].partNbr,
            linesideAddress: response?.data?.getDuplicateHotCalls[0].lsAddrTxt,
            currentBodyNumber: response?.data?.getDuplicateHotCalls[0].seqNbr,
            piecesRemaining: response?.data?.getDuplicateHotCalls[0].pcsRem,
            vehiclesToEmpty: response?.data?.getDuplicateHotCalls[0].intVhcleEmpty,
            firstMissedPartSeqNo: response?.data?.getDuplicateHotCalls[0].firMsdSeq,
            firstMissedPartBodyNo: response?.data?.getDuplicateHotCalls[0].firVhlSeq,
            tpCount: response?.data?.getDuplicateHotCalls[0].trkPntName,
            tpErrorMessage: '',
            currentVehicleSeq: response?.data?.getDuplicateHotCalls[0].seqNbr,
            lineSideComments: ''
            };
          this.spinner.hide();
          this.currentSection = 2;
        }
        if(response?.data?.getDuplicateHotCalls.length === 0) {
          this.isDuplicateTicket = false;
          this.spinner.hide();
          this.onHotCallSubmit(action);
          this.currentSection = 3
        }
        if(response?.errors) {
          this.spinner.hide();
          this.errorService.setErrorMessage([]);
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

  public onCancel(): void {
    this.translate.get(['cancelTicket.title', 'cancelTicket.message']).subscribe(translations => {
      const dialogRef = this.dialog.open(SubmitDialogeComponent, {
        width: '567px',
        panelClass: 'centered-dialog',
        data: {
          message: translations['cancelTicket.message'],
          title: translations['cancelTicket.title'],
          showCancelButton: true,
          action: "Cancel Hot Call",
          showYesButton: true,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === true) {
            if (this.timerSubscription) {
                this.timerSubscription.unsubscribe();
            }
            if (this.currentSection === 3) {
                this.onHotCallSubmit('Cancel');
            } else {
              this.router.navigateByUrl('home');
            }
        }
      });
    });
  }

  public onUpdatePopUp(ticketId: string): void {
    this.translate.get(['updateRunoutInformation.title', 'updateRunoutInformation.message']).subscribe({
      next: (translations) => {
        const dialogRef = this.dialog.open(UpdateRunoutInformationComponent, {
          panelClass: 'centered-dialog',
          width: '100vw',
          minWidth: '80vw',
          data: {
            message: translations['updateRunoutInformation.message'],
            title: translations['updateRunoutInformation.title'],
            runOutData: this.runOutData,
            oldRunOutData: this.oldRunOutInfo,
            ticketId: this.duplicateTicketId,
          }
        });
        dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
          if (result) {
            this.startTimer();
          } else {
              this.isDuplicateTicket = false;
          }
        });
      }
    });
  }

  private getNamcName(): void {
    let namcName = '';
    this.service.getNamc().subscribe({
      next: (response) => {
        namcName = response;
      },
      error: (error) => {
        console.log('Error in fetching namc name');
      }
    });
    this.namcId = getNamcIdForName(namcName);
  }

  public getRunOutInformation(businessEntity: string): void {
    this.disableSubmit = false;
    this.spinner.show();
    const partNumber = this.form.get('partnumber')?.value || ""
    const lineSideaddress = this.form.get('deliveryAddress')?.value || ""
    const suppliedCode = '00' + (this.form.get('supplier')?.value || "")
    const dockCode = this.form.get('dock')?.value || ""
    const kanbanCode = this.form.get('kanban')?.value || ""
    const numberOfBoxes = this.form.get('numberOfFullBoxes')?.value || ""
    const numberOfPieces = this.form.get('quantityOfBox')?.value || ""
    const percentaOfBox = this.form.get('percentageOfBox')?.value || 0
    const trackingPointID = 1
    const currentBodyNumber = this.form.get('bodyNumber')?.value || ""
    const lineNames = Array.isArray(this.userRoles.lineName) ? this.userRoles.lineName.join('|') : this.userRoles.lineName;
    const query = `${apiEndPoints.GetRunOutInformation}?${apiQueryParams.business_entity}=${businessEntity}&${apiQueryParams.PlantName}=${this.userRoles.plant}&${apiQueryParams.ShopName}=${this.userRoles.shop}&${apiQueryParams.LineName}=${encodeURIComponent(lineNames)}&${apiQueryParams.PartNo}=${partNumber}&${apiQueryParams.lineSideAddress}=${lineSideaddress}&${apiQueryParams.supplierCode}=${suppliedCode}&${apiQueryParams.dockCode}=${dockCode}&${apiQueryParams.kanbanCode}=${kanbanCode}&${apiQueryParams.numberOfBoxes}=${numberOfBoxes}&${apiQueryParams.numberOfPieces}=${numberOfPieces}&${apiQueryParams.percentageOfBox}=${percentaOfBox}&${apiQueryParams.trackingID}=${trackingPointID}&${apiQueryParams.currentBodyNumber}=${currentBodyNumber}`;
    this.service.getPieData(query).subscribe({
      next: (data: GetRunOutInfoApiResponse) => {
        if (data?.hasError === 'false' && data?.httpStatusCode === '200') {
          this.errorList = [];
          this.runOutData = {
            supplierCode: data.responseBody.supplier_code,
            dockCode: data.responseBody.dock_code,
            kanbanCode: data.responseBody.kanban_code,
            partNumber: data.responseBody.part_no,
            linesideAddress: data.responseBody.line_name, // Adjust as per data.responseBody, might need to update based on the API.
            currentBodyNumber: data.responseBody.current_body_number,
            piecesRemaining: data.responseBody.piecesRemaining,
            vehiclesToEmpty: data.responseBody.VehiclesToEmpty,
            firstMissedPartSeqNo: data.responseBody.FirstMissedPartSeqNo,
            firstMissedPartBodyNo: data.responseBody.FirstMissedPartBodyNo,
            tpCount: data.responseBody.tpCount,
            tpErrorMessage: data.responseBody.tpErrorMessage,
            currentVehicleSeq: this.form.get('sequenceNumber')?.value || "",
            lineSideComments: this.form.get('lineSideComments')?.value || ""
          };
          this.duplicateHotCallCheck('Inquiry');
          // this.onHotCallSubmit('Inquiry');
          // this.currentSection = 3;
          this.dataService.updateStepNumber(3);
          this.startTimer();
          this.spinner.hide();
        } if(data?.hasError === 'true' && data?.responseMessage) {
          this.spinner.hide();
          this.disableSubmit = true;
          this.successList = [];
          this.errorService.setErrorMessage([]);
        }
        if(data?.hasError === 'true' && data?.responseBody?.Errors?.errorsMsg) {
          this.spinner.hide();
          this.successList = [];
          this.disableSubmit = true;
          this.errorService.setErrorMessage(data.responseBody.Errors.errorsMsg);
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.disableSubmit = true;
        this.successList = [];
        this.errorService.setErrorMessage([]);
      },
      complete: () => {
        this.spinner.hide();
      }
    })
  }
  public getVehicleDetails(businessEntity: string): void {
    this.spinner.show();
    const sequenceNumber = this.form.get('sequenceNumber')?.value || "";
    const bodyNumber = this.form.get('bodyNumber')?.value || "";
    let query = `${apiEndPoints.GetVehicleDetails}?${apiQueryParams.business_entity}=${businessEntity}&${apiQueryParams.PlantName}=${String(this.userRoles.plant).trim()}&${apiQueryParams.ShopName}=${String(this.userRoles.shop).trim()}`;
    query += sequenceNumber ? `&${apiQueryParams.sequenceNumber}=${String(sequenceNumber).trim()}` : '';
    query += bodyNumber ? `&${apiQueryParams.bodyNumber}=${String(bodyNumber).trim()}` : '';

    // Make the API call to fetch vehicle details
    this.service.getPieData(query).subscribe({
      next: (data: GetVehiclDetailsApiResponse) => {
        if (data?.hasError === 'false' && data?.httpStatusCode === '200') {
          this.errorList = [];
          if (data?.responseBody?.BodyNumber) {
            this.form.patchValue({
              bodyNumber: data.responseBody.BodyNumber
            });
          }
          if (data?.responseBody?.SequenceNumber) {
            this.form.patchValue({
              sequenceNumber: data.responseBody.SequenceNumber
            });
          }
          this.spinner.hide();
        } if(data?.hasError === 'true' && data?.responseMessage) {
          this.successList = [];
          this.errorService.setErrorMessage([data.responseMessage]);
          this.spinner.hide();

        }
        if(data?.hasError === 'true' && data?.responseBody?.Errors?.errorsMsg) {
          this.successList = [];
          this.errorService.setErrorMessage(data.responseBody.Errors.errorsMsg);
          this.spinner.hide();
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.successList = [];
        this.errorService.setErrorMessage([]);
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

  public handleShopCondition(): void {
    if (this.isShopWithNoSequenceNumber()) {
      this.getFirstSequenceNumber(this.namcId);
    }
  }

  public getFirstSequenceNumber(businessEntity: string) {
    this.spinner.show();
    const partNumber = this.form.get('partnumber')?.value || ""
    const lineSideaddress = this.form.get('deliveryAddress')?.value || ""
    const suppliedCode = this.form.get('supplier')?.value || ""
    const dockCode = this.form.get('dock')?.value || ""
    const kanbanCode = this.form.get('kanban')?.value || ""
    let query = `${apiEndPoints.GetFirstSequenceNumber}?${apiQueryParams.business_entity}=${String(businessEntity).trim()}&${apiQueryParams.PlantName}=${String(this.userRoles.plant).trim()}&${apiQueryParams.ShopName}=${String(this.userRoles.shop).trim()}&${apiQueryParams.PartNo}=${partNumber}&${apiQueryParams.lineSideAddress}=${lineSideaddress}&${apiQueryParams.supplierCode}=${suppliedCode}&${apiQueryParams.dockCode}=${dockCode}&${apiQueryParams.kanbanCode}=${kanbanCode}`;
    this.service.getPieData(query).subscribe({
      next: (data: GetFirstSequenceApiResponse) => {
        if (data?.hasError === 'false' && data?.httpStatusCode === '200') {
          this.errorList = [];
          if (data?.responseBody?.body_number) {
            this.form.get('bodyNumber')?.patchValue(data.responseBody.body_number);
          }
          this.spinner.hide();
        } if(data?.hasError === 'true' && data?.responseMessage) {
          this.successList = [];
          this.errorService.setErrorMessage([data.responseMessage]);
          this.spinner.hide();
        }
        if(data?.hasError === 'true' && data?.responseBody?.Errors?.errorsMsg) {
          this.successList = [];
          this.errorService.setErrorMessage(data.responseBody.Errors.errorsMsg);
          this.spinner.hide();
        }
      },
      error: (error: any) => {
        this.spinner.hide();
        this.successList = [];
        this.errorService.setErrorMessage([]);
      },
    });
  }

  public ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    if (this.kanbanValueChangeSubscription) {
      this.kanbanValueChangeSubscription.unsubscribe();
    }
    if (this.quantityTypeSubscription) {
      this.quantityTypeSubscription.unsubscribe();
    }
    if (this.partNumberSubscription) {
      this.partNumberSubscription.unsubscribe();
    }
    if (this.sequenceNumberSubscription) {
      this.sequenceNumberSubscription.unsubscribe();
    }
    if (this.bodyNumberSubscription) {
      this.bodyNumberSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

}